import Backbone from 'backbone'
import Slides from './slides'
import permissions from 'scoreboard/components/permissions'


var BriefingBook = Backbone.Model.extend({

	section: 'briefings',
	domainType: 'briefing',
	urlRoot: 'api/briefings',

	initialize: function() {
		this.on('change:slides', function() {
			this._slides = null
		})
	},

	isEditable: function() {
		return permissions.briefings(this.get('organizationId'))
	},

	// returns a Backbone.Collection of the slides
	slides: function() {
		if (!this._slides) {
			this._slides = new Slides(this.get('slides'))
			// make sure each slide knows its briefingId.  That isn't sent
			// from the server because it would be redundant.  Also provide
			// a reference to the parent briefing
			this._slides.forEach(function(slide) {
				slide.briefing = this
				slide.set('briefingId', this.id, { silent: true })
			}.bind(this))
			// keep the briefing in sync with changes to its slides.  Note
			// the slide nav is listening for the change:slides event to
			// re-render itself
			this._slides.on('change add remove', function() {
				// for some reason if you edit a slide over and over, this
				// check is needed
				if (this._slides) {
					this.set('slides', this._slides.toJSON())
				}
			}.bind(this))
		}
		return this._slides
	}

})

export default BriefingBook

BriefingBook.__filename__ = 'briefings/briefing.js'
